import { useContext } from 'react'
import { useNavigate } from 'react-router-dom'

import { navigateTo } from '@/common/components/PageLayout/hooks/useReturnPortals/helpers'
import AppContext from '@/common/context/app.context'

const useOpenParcelDetail = ({ storeId }) => {
  const { info, updateContext } = useContext(AppContext)
  const navigate = useNavigate()

  const handleOpenParcelDetail = url => {
    if (storeId === info.selectedStore.id) return navigate(url)

    const store = info.stores.find(store => store.id === storeId)

    localStorage.selectedStore = JSON.stringify(store)
    localStorage.forceChangeStore = true
    updateContext(info => ({ ...info, selectedStore: store }))
    navigateTo(url)
  }

  return { handleOpenParcelDetail }
}

export default useOpenParcelDetail
